import type { BudgetType } from '@/types/api.types'

/**
 * Format a budget range for display.
 *
 * Examples:
 * - Hourly:  "$50–100/hr"
 * - Fixed:   "$500–2,000"
 * - Monthly: "$3,000–5,000/mo"
 */
export function formatBudgetRange(
  type: BudgetType,
  min: number,
  max: number,
): string {
  const fmt = (n: number) => n.toLocaleString('en-US')
  const suffix = type === 'hourly' ? '/hr' : type === 'monthly' ? '/mo' : ''

  if (min === max) {
    return `$${fmt(min)}${suffix}`
  }

  return `$${fmt(min)}–${fmt(max)}${suffix}`
}

/**
 * Format a budget type label.
 */
export function formatBudgetTypeLabel(type: BudgetType): string {
  switch (type) {
    case 'hourly': return 'Hourly'
    case 'fixed': return 'Fixed Price'
    case 'monthly': return 'Monthly'
    default: return type
  }
}
